import { Action, ErrorCodes, OperationType, Position } from "puzzle";
import MultiClaimTasksWarning from "../components/SupplierView/MultiClaimUnclaim/MultiClaimTasksWarning";
import MultiClaimFailedTasksWarning from "../components/SupplierView/MultiClaimUnclaim/MultiClaimFailedTasksWarning";

export const showMultiClaimFailedTasks: Action = [{
  title: 'multiClaimFailedTask.title',
  children: [{
    render: MultiClaimFailedTasksWarning,
    propArgs: ['data', 'claimSwitch']
  }],
  className: 'sm warning pd-claim-tasks-warning',
  items: [{
    btnName: 'multiClaimFailedTask.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }],
  type: OperationType.dialog
}]

export const multiClaimConfirmation: Action = [{
  placeholders: {
    template: {
      bind: {
        taskNumber: `_.get({checkedItems}, "taskIds.length")} + (_.get({responseData}, "length")} || 0)`,
      }
    }
  },
  className: 'sm',
  text: 'multiClaimConfirm.textClaim',
  title: 'multiClaimConfirm.claim',
  type: OperationType.warning,
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      persistent: ['checkedItems', 'responseData'],
      type: OperationType.removePersistentData
    }]
  }, {
    btnName: 'multiClaimConfirm.cancel',
    operations: [{
      persistent: ['checkedItems', 'responseData'],
      type: OperationType.removePersistentData
    }],
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'multiClaimConfirm.claim',
    operations: [{
      condition: '_.get({checkedItems}, "taskIds.length")}',
      conditionOperations: [{
        actionType: {
          dispatcherId: 'massClaimDispatcher'
        },
        data: {
          template: {
            massUrl: "/jobPhase/massTasksClaim",
            bind: {
              linkedTasksNumber: '_.get({responseData}, "length")}'
            }
          }
        },
        name: 'massClaimTasksRequest',
        type: OperationType.action
      }, {
        actionType: {
          dispatcherId: 'massClaimDispatcher'
        },
        name: 'massTaskClaimPing',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }, {
      persistent: ['responseData'],
      type: OperationType.removePersistentData
    }],
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    }
  }]
}]

export const massTaskUnclaimPing: Action = [{
  condition: '{responseData} && {responseData.processingFinished}',
  conditionOperations: [{
    data: {
      template: {
        notification: {
          notificationName: 'unclaim',
          bind: {
            id: '{processId}'
          }
        }
      }
    },
    moduleName: 'ToastNotifications',
    moduleId: 'ToastNotificationsViewport',
    name: 'handleMultiClaimNotificationsOnFinish',
    args: ['notification', 'responseData', 'checkedItems', 'linkedTasksNumber']
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'finishMassUnclaimAction',
    type: OperationType.action
  }],
  elseOperations: [{
    actionType: {
      delay: 1200
    },
    name: 'massUnclaimUUIDRequest',
    type: OperationType.stack
  }],
  type: OperationType.conditional
}];

export const massTaskClaimPing: Action = [{
  condition: '{responseData} && {responseData.processingFinished}',
  conditionOperations: [{
    data: {
      template: {
        notification: {
          notificationName: 'claim',
          bind: {
            id: '{processId}'
          }
        }
      }
    },
    moduleName: 'ToastNotifications',
    moduleId: 'ToastNotificationsViewport',
    name: 'handleMultiClaimNotificationsOnFinish',
    args: ['notification', 'responseData', 'checkedItems', 'linkedTasksNumber']
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'finishMassClaimAction',
    type: OperationType.action
  }],
  elseOperations: [{
    actionType: {
      delay: 1200
    },
    name: 'massClaimUUIDRequest',
    type: OperationType.stack
  }],
  type: OperationType.conditional
}];

export const finishMassUnclaimAction: Action = [{
  name: 'removeMassUnclaimDispatcher',
  type: OperationType.action
}, {
  name: 'checkboxSelectionClear',
  type: OperationType.action
}, {
  name: 'refreshApp',
  type: OperationType.action
}, {
  persistent: ['checkedItems'],
  type: OperationType.removePersistentData
}]

export const finishMassClaimAction: Action = [{
  name: 'removeMassClaimDispatcher',
  type: OperationType.action
}, {
  name: 'checkboxSelectionClear',
  type: OperationType.action
}, {
  name: 'refreshApp',
  type: OperationType.action
}, {
  persistent: ['checkedItems'],
  type: OperationType.removePersistentData
}]

export const removeMassUnclaimDispatcher: Action = [{
  dispatcherIds: ['massUnclaimDispatcher'],
  type: OperationType.stopAll
}, {
  dispatcherIds: ['massUnclaimDispatcher'],
  type: OperationType.unlink
}];

export const removeMassClaimDispatcher: Action = [{
  dispatcherIds: ['massClaimDispatcher'],
  type: OperationType.stopAll
}, {
  dispatcherIds: ['massClaimDispatcher'],
  type: OperationType.unlink
}];

export const massUnclaimUUIDRequest = [{
  data: {
    template: {
      headers: {
        bind: {
          'X-Process-Uuid': '{processId}'
        }
      },
      url: "/jobPhase/massTasksUnclaim"
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  name: 'massTaskUnclaimPing',
  type: OperationType.action
}];

export const massClaimUUIDRequest = [{
  data: {
    template: {
      headers: {
        bind: {
          'X-Process-Uuid': '{processId}'
        }
      },
      url: "/jobPhase/massTasksClaim"
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  name: 'massTaskClaimPing',
  type: OperationType.action
}];

//Action used both for claim and unclaim w/ corresponding dispatcherId and url
export const massClaimTasksRequest: Action = [{
  data: {
    template: {
      bind: {
        url: '{massUrl}',
        params: '{checkedItems}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        processId: '{responseData.processId}',
      }
    }
  },
  type: OperationType.data
}, {
  moduleName: 'ToastNotifications',
  moduleId: 'ToastNotificationsViewport',
  name: 'setProcessingNotification',
  args: ['processId']
}]

export const multiUnclaimConfirmation: Action = [{
  placeholders: {
    template: {
      bind: {
        taskNumber: `_.get({checkedItems}, "taskIds.length")} + (_.get({responseData}, "length")} || 0)`,
      }
    }
  },
  className: 'sm error',
  text: 'multiClaimConfirm.textUnclaim',
  title: 'multiClaimConfirm.unclaim',
  type: OperationType.warning,
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      persistent: ['checkedItems', 'responseData'],
      type: OperationType.removePersistentData
    }]
  }, {
    btnName: 'multiClaimConfirm.cancel',
    operations: [{
      persistent: ['checkedItems', 'responseData'],
      type: OperationType.removePersistentData
    }],
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'multiClaimConfirm.unclaim',
    operations: [{
      condition: '_.get({checkedItems}, "taskIds.length")}',
      conditionOperations: [{
        condition: '_.get({responseData}, "length")}',
        conditionOperations: [{
          data: {
            template: {
              checkedItems: {
                bind: {
                  taskIds: `_.concat({checkedItems.taskIds}, _.map({responseData}, 'taskId'))`
                }
              }
            }
          },
          type: OperationType.data
        }],
        type: OperationType.conditional
      }, {
        actionType: {
          dispatcherId: 'massUnclaimDispatcher'
        },
        data: {
          template: {
            massUrl: "/jobPhase/massTasksUnclaim",
            bind: {
              linkedTasksNumber: '_.get({responseData}, "length")}'
            }
          }
        },
        name: 'massClaimTasksRequest',
        type: OperationType.action
      }, {
        actionType: {
          dispatcherId: 'massUnclaimDispatcher'
        },
        name: 'massTaskUnclaimPing',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }, {
      persistent: ['responseData'],
      type: OperationType.removePersistentData
    }],
    btnConfig: {
      themeColor: 'error',
      pos: Position.end
    }
  }]
}]

export const showMultiClaimTasksWarning: Action = [{
  data: {
    claimSwitch: 'Claim'
  },
  title: 'claimLinkedTasksWarning.titleClaim',
  children: [{
    render: MultiClaimTasksWarning,
    propArgs: ['responseData', 'claimSwitch']
  }],
  className: 'sm warning pd-claim-tasks-warning',
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      persistent: ['checkedItems', 'responseData'],
      type: OperationType.removePersistentData
    }]
  }, {
    btnName: 'claimLinkedTasksWarning.cancel',
    operations: [{
      persistent: ['checkedItems', 'responseData'],
      type: OperationType.removePersistentData
    }],
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'claimLinkedTasksWarning.continue',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    },
    operations: [{
      name: 'multiClaimConfirmation',
      type: OperationType.action
    }]
  }],
  type: OperationType.dialog
}]

export const showMultiUnclaimTasksWarning: Action = [{
  data: {
    claimSwitch: 'Unclaim'
  },
  title: 'claimLinkedTasksWarning.titleUnclaim',
  children: [{
    render: MultiClaimTasksWarning,
    propArgs: ['responseData', 'claimSwitch']
  }],
  className: 'sm warning pd-claim-tasks-warning',
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      persistent: ['checkedItems', 'responseData'],
      type: OperationType.removePersistentData
    }]
  }, {
    btnName: 'claimLinkedTasksWarning.cancel',
    operations: [{
      persistent: ['checkedItems', 'responseData'],
      type: OperationType.removePersistentData
    }],
    btnConfig: {
      pos: Position.end
    }
  }, {
    btnName: 'claimLinkedTasksWarning.continue',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    },
    operations: [{
      name: 'multiUnclaimConfirmation',
      type: OperationType.action
    }]
  }],
  type: OperationType.dialog
}]

export const masClaimUnclaimInitial: Action = [{
  moduleName: 'MainGrid',
  name: 'getCheckedTaskIds',
  mappingName: 'checkedItems',
  type: OperationType.addOperationData
}, {
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    template: {
      bind: {
        url: '{url}',
        params: '{checkedItems}'
      }
    }
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  persistent: ['checkedItems'],
  type: OperationType.addPersistentData
}]

export const mass_unclaim_job_phase: Action = [{
  data: {
    url: '/jobPhase/getDependentUnclaimTasks',
  },
  name: 'masClaimUnclaimInitial',
  type: OperationType.action
}, {
  condition: '{responseData.length}',
  conditionOperations: [{
    persistent: ['responseData'],
    type: OperationType.addPersistentData
  }, {
    name: 'showMultiUnclaimTasksWarning',
    type: OperationType.action
  }],
  elseOperations: [{
    name: 'multiUnclaimConfirmation',
    type: OperationType.action
  }],
  type: OperationType.conditional
}]

export const mass_claim_job_phase: Action = [{
  data: {
    url: '/jobPhase/getDependentClaimTasks',
  },
  name: 'masClaimUnclaimInitial',
  type: OperationType.action
}, {
  condition: '{responseData.length}',
  conditionOperations: [{
    persistent: ['responseData'],
    type: OperationType.addPersistentData
  }, {
    name: 'showMultiClaimTasksWarning',
    type: OperationType.action
  }],
  elseOperations: [{
    name: 'multiClaimConfirmation',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];
